import "./SiteConfigurationGroups.html";
import "./SiteConfigurationGroups.scss";
import "./SiteConfigurationGroupSchedules.scss";

import "./Add/SiteConfigurationGroupAddComponent";
import "./Care/SiteConfigurationGroupCareComponent";
import "./Detection/SiteConfigurationGroupDetectionComponent";
import "./Monitoring/SiteConfigurationGroupMonitoringComponent";
import "./Recording/SiteConfigurationGroupRecordingComponent";
import "./Reporting/SiteConfigurationGroupReportingComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import SiteConfigurationGroupsComponentController from "./SiteConfigurationGroupsComponentController";

export class SiteConfigurationGroupsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            siteId: "<",
        };
        this.controller = SiteConfigurationGroupsComponentController;
        this.templateUrl = "/App/Components/Site/ConfigurationGroups/SiteConfigurationGroups.html";
    }
}

module("mmManagePortal").component("mmSiteConfigurationGroups", new SiteConfigurationGroupsComponent());
